/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { TeamMemberDtoModel, TeamMemberDtoModelType } from "./TeamMemberDtoModel"
import { TeamMemberDtoModelSelector } from "./TeamMemberDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  node: TeamMemberDtoModelType;
}

/**
 * TeamMemberDtoEdgeBase
 * auto generated base class for the model TeamMemberDtoEdgeModel.
 */
export const TeamMemberDtoEdgeModelBase = withTypedRefs<Refs>()(ModelBase
  .named('TeamMemberDtoEdge')
  .props({
    __typename: types.optional(types.literal("TeamMemberDtoEdge"), "TeamMemberDtoEdge"),
    cursor: types.union(types.undefined, types.string),
    node: types.union(types.undefined, MSTGQLRef(types.late((): any => TeamMemberDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class TeamMemberDtoEdgeModelSelector extends QueryBuilder {
  get cursor() { return this.__attr(`cursor`) }
  node(builder: string | TeamMemberDtoModelSelector | ((selector: TeamMemberDtoModelSelector) => TeamMemberDtoModelSelector) | undefined) { return this.__child(`node`, TeamMemberDtoModelSelector, builder) }
}
export function selectFromTeamMemberDtoEdge() {
  return new TeamMemberDtoEdgeModelSelector()
}

export const teamMemberDtoEdgeModelPrimitives = selectFromTeamMemberDtoEdge().cursor
